import { useQuery } from '@tanstack/react-query';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { AppMedError } from '../../../error/AppMedError';
import { BillingApi } from '../../../apis/BillingApi/BillingApi';
import { IBillingReportFilter, BillingReport } from '../BillingTypes';

export const useBillingReport = (filters: IBillingReportFilter) => {
    const {
        data: billingData,
        isLoading,
        error,
        refetch,
    } = useQuery<BillingReport, AppMedError>({
        queryKey: [QueryKeys.billingReport, filters],
        queryFn: () => BillingApi.getBillingReport(filters),
        staleTime: 2 * 60 * 1000, // 2 minutes
        retry: 1,
    });

    return {
        billingData,
        isLoading,
        error,
        refetch,
    };
}; 